import { FKC_MAX_CARD_COUNT } from "./fkc.constants";

/**
 * Function to get the number of cards that can be added to recieve entries based
 * on the number of accounts to be added and the number of cards already added
 * @param accounts How many accounts to add
 * @param cardsCount How many cards are already added
 * @returns The number of cards that can be added
 */
export function getFkcAddedCards(accounts: number, cardsCount: number): number {
  return Math.max(0, Math.min(FKC_MAX_CARD_COUNT - cardsCount, accounts));
}
